<template>
	<div class="flex w-full justify-center px-8 sm:px-20 py-32 md:py-12">
		<div class="w-full max-w-2xl lg:max-w-4xl text-ihh-slate-gray space-y-12 text-base leading-8">
			<div class="sendlane-form" data-form-key="eyJkb21haW4iOiJpbmhpc2hhbmRzIiwiZm9ybV9pZCI6Ijk1YWRmYWE0LWFiNTMtNDE4OS05NDcxLWVlMjU2MWM0ZTc5OSJ9"></div>
		</div>
	</div>
</template>

<script setup>
import { onMounted } from 'vue'

onMounted(() => {
	console.log('mounted')

	// re-init sendlane
	if (window._Sendlane) {
		window._Sendlane.push({ form_key: 'eyJkb21haW4iOiJpbmhpc2hhbmRzIiwiZm9ybV9pZCI6Ijk1YWRmYWE0LWFiNTMtNDE4OS05NDcxLWVlMjU2MWM0ZTc5OSJ9' })
	}
})
</script>
